import ellipsis from './ellipsis.vue';

export default ellipsis;
